function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { View, Pressable } from 'react-native';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
import Spacer from '../spacer';
import Tooltip from '../tooltip';
import Currency from '../utilities/currency';
import useMobile from '../hooks/use-mobile';
const contentColors = {
  default: Colors.gray400,
  emphasis: Colors.gray600,
  discount: Colors.advanceBlue400,
  discounted: Colors.gray200,
  collapsed: Colors.gray600,
  expanded: Colors.gray600,
  total: Colors.gray600,
  fees: Colors.gray400
};

const contentWeight = type => {
  if (type === 'default' || type === 'discounted' || type === 'fees') return 'regular';
  return 'medium';
};

const StyledContainer = container => {
  const Container = container.type === 'collapsed' || container.type === 'expanded' ? Pressable : View;
  const style = {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: container.type === 'total' || container.type === 'fees' ? 26 : 27
  };
  return /*#__PURE__*/React.createElement(Container, {
    style: style,
    onPress: container.onPress
  }, container.children);
};

const IconContainer = styled.Pressable`
  margin-right: auto;
`;
const StyledGroup = styled.View`
  margin-left: auto;
  flex-direction: row;
`;
const StyledContent = styled.View`
  padding-top: 3.5px;
  height: 27px;
`;

const DiscountedAmount = content => /*#__PURE__*/React.createElement(Text.BodySmall, {
  weight: "medium",
  color: Colors.gray600
}, Currency.pesoFormat(content.amount), ' ');

const StyledIcon = tooltip => {
  const useHover = () => {
    const [hovered, setHovered] = useState();
    const eventHandlers = useMemo(() => ({
      onMouseOver() {
        setHovered(true);
      },

      onMouseOut() {
        setHovered(false);
      }

    }), []);
    return [hovered, eventHandlers];
  };

  const [hovered, eventHandlers] = useHover();
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    if (!tooltip.mobile && hovered) setShowTooltip(true);
  }, [hovered, showTooltip]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    width: true
  }), /*#__PURE__*/React.createElement(Tooltip, {
    visible: showTooltip,
    title: tooltip.title,
    content: tooltip.content,
    onClose: () => setShowTooltip(false),
    renderIcon: () => /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
      name: "info",
      color: Colors.advanceBlue300,
      size: 20
    }),
    contentMaxWidth: tooltip.contentMaxWidth,
    textWidth: tooltip.textWidth
  }, /*#__PURE__*/React.createElement(IconContainer, _extends({
    onPress: () => tooltip.mobile && setShowTooltip(true)
  }, eventHandlers), /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "info",
    color: Colors.purple400,
    size: 14
  }))));
};

const Dropdown = arrow => {
  const direction = arrow.type === 'expanded' ? 'down' : 'up';
  const style = {
    paddingTop: 2
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    width: true
  }), /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: `keyboard-arrow-${direction}`,
    size: 16,
    color: Colors.gray600,
    style: style
  }));
};

export default function BreakdownRow(props) {
  const type = Object.keys(contentColors).includes(props.type) ? props.type : BreakdownRow.defaultProps.type;
  const mobile = useMobile();
  return /*#__PURE__*/React.createElement(StyledContainer, {
    type: type,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: type === 'total' ? 'medium' : 'regular',
    color: type === 'total' ? Colors.gray600 : Colors.gray300
  }, props.label), type === 'fees' && /*#__PURE__*/React.createElement(StyledIcon, _extends({
    mobile: mobile
  }, props.tooltip)), /*#__PURE__*/React.createElement(StyledGroup, null, type === 'discounted' && /*#__PURE__*/React.createElement(DiscountedAmount, {
    amount: props.discountedAmount
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: contentWeight(type),
    color: contentColors[type],
    textDecorationLine: type === 'discounted' ? 'line-through' : 'none'
  }, props.children && /*#__PURE__*/React.createElement(StyledContent, {
    type: type
  }, props.children) || /*#__PURE__*/React.createElement(React.Fragment, null, type === 'discount' && '-', Currency.pesoFormat(props.amount))), (type === 'collapsed' || type === 'expanded') && /*#__PURE__*/React.createElement(Dropdown, {
    type: type
  })));
}
BreakdownRow.defaultProps = {
  type: 'default',
  label: 'Label',
  amount: 0,
  discountedAmount: 0,
  onPress: () => {},
  children: '',
  tooltip: {
    title: '',
    content: '',
    contentMaxWidth: 200,
    textWidth: 136
  }
};
BreakdownRow.propTypes = {
  type: PropTypes.oneOf(Object.keys(contentColors)),
  label: PropTypes.string,
  amount: PropTypes.number,
  discountedAmount: PropTypes.number,
  onPress: PropTypes.func,
  children: PropTypes.node,
  tooltip: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    contentMaxWidth: PropTypes.number,
    textWidth: PropTypes.number
  })
};
//# sourceMappingURL=index.js.map